export default (theme) => ({
  card: {
    background: '#FFF',
    boxShadow: 'none',
    borderRadius: 20,

    [theme.breakpoints.up(768)]: {
      borderRadius: 0,
      flex: 1,
    },

    '& .MuiCardContent-root': {
      height: '100%',
      minHeight: 315,
      padding: '34px 18.5px',
      gap: 45,

      '&:last-child': {
        paddingBottom: 34,
      },

      [theme.breakpoints.up(768)]: {
        padding: 0,
        minHeight: 253,
        gap: 40,

        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 23,
  },
  cardContentTitle: {
    color: '#49454F',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '0.5px',

    [theme.breakpoints.up(768)]: {
      fontSize: 18,
      lineHeight: '27px',
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: 24,
    },
  },
  cardContentInputs: {
    display: 'flex',
    gap: 23,
    flexDirection: 'column',

    '& .MuiInputLabel-outlined': {
      color: '#8B54F7',
    },

    '& .MuiSelect-icon': {
      fontSize: 40,
      top: 'calc(50% - 20px)',
      color: '#8B54F7',

      '&.MuiSelect-iconOpen': {
        transform: 'rotate(90deg)',
      },
    },

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#8B54F7',
      },
    },

    '& .MuiFormGroup-root': {
      justifyContent: 'space-between',

      '& .MuiFormControlLabel-root': {
        margin: 0,

        '& .MuiRadio-root': {
          padding: 6,
        },

        '& .MuiFormControlLabel-label': {
          fontSize: 15,
          fontWeight: 400,
          lineHeight: '22px',
          color: 'rgba(47, 43, 61, 0.9)',
        },
      },
    },

    [theme.breakpoints.up(768)]: {
      '& .MuiFormGroup-root': {
        justifyContent: 'flex-start',
        gap: 16,
      },
    },
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.up(768)]: {
      alignItems: 'flex-end',
    },
  },
  cardActionsButton: {
    maxWidth: 162,

    '& .MuiButton-root': {
      padding: 0,
      borderRadius: 16,
      minHeight: 40,
      textAlign: 'center',
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '19.2px',
      textTransform: 'none',
    },

    [theme.breakpoints.up(768)]: {
      maxWidth: 148,

      '& .MuiButton-root': {
        minHeight: 48,
        fontSize: 14,
        lineHeight: '16.8px',
      },
    },
  },
});
